import { createContext, useContext, useEffect, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 993);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.screen.width < 993);
        }
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <AppContext.Provider value={{ isMobile }}>
            {children}
        </AppContext.Provider>
    )
};

export const useAppContext = () => {
    return useContext(AppContext);
};

